import React, { useState } from 'react';
import { isValidASIN } from '../utils/export';

const MARKETPLACES = [
  { value: 'com', label: '🇺🇸 Amazon.com' },
  { value: 'co.uk', label: '🇬🇧 Amazon.co.uk' },
  { value: 'de', label: '🇩🇪 Amazon.de' },
  { value: 'ca', label: '🇨🇦 Amazon.ca' },
  { value: 'in', label: '🇮🇳 Amazon.in' },
];

export default function SearchForm({ onSubmit, isRunning, onReset, isDone, defaultASIN, defaultMarketplace }) {
  const [asin, setAsin] = useState(defaultASIN || '');
  const [marketplace, setMarketplace] = useState(defaultMarketplace || 'com');
  const [validationMsg, setValidationMsg] = useState('');

  function handleChange(e) {
    const val = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10);
    setAsin(val);
    if (validationMsg) setValidationMsg('');
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!isValidASIN(asin)) {
      setValidationMsg('ASINs are exactly 10 characters (letters and numbers). Example: B08N5WRWNW');
      return;
    }
    onSubmit(asin, marketplace);
  }

  return (
    <div className="search-card">
      <form onSubmit={handleSubmit}>
        <div className="search-row">
          <div className="asin-input-wrapper">
            <span className="input-icon" aria-hidden="true">#</span>
            <input
              className="asin-input"
              type="text"
              value={asin}
              onChange={handleChange}
              placeholder="Paste competitor ASIN — e.g. B08N5WRWNW"
              maxLength={10}
              autoComplete="off"
              autoCorrect="off"
              spellCheck={false}
              autoCapitalize="characters"
              aria-label="Amazon ASIN"
              disabled={isRunning}
            />
          </div>
          <select
            className="marketplace-select"
            value={marketplace}
            onChange={e => setMarketplace(e.target.value)}
            disabled={isRunning}
            aria-label="Marketplace"
          >
            {MARKETPLACES.map(m => (
              <option key={m.value} value={m.value}>{m.label}</option>
            ))}
          </select>
          {isDone ? (
            <button
              type="button"
              className="search-btn"
              onClick={onReset}
              style={{ background: 'var(--bg-subtle)', color: 'var(--text-secondary)' }}
            >
              ↩ New lookup
            </button>
          ) : (
            <button
              type="submit"
              className="search-btn"
              disabled={isRunning || asin.length < 10}
            >
              {isRunning ? (
                <>
                  <span style={{ display: 'inline-block', animation: 'spin 1s linear infinite' }}>⌛</span>
                  Analyzing…
                </>
              ) : (
                <>
                  Extract Keywords →
                </>
              )}
            </button>
          )}
        </div>

        {validationMsg && (
          <p style={{ fontSize: 12.5, color: 'var(--error)', marginTop: 8, paddingLeft: 2 }}>
            ⚠ {validationMsg}
          </p>
        )}

        {!validationMsg && (
          <div className="search-hints">
            <span className="hint-item">✓ No account needed</span>
            <span className="hint-item">✓ Real organic rankings</span>
            <span className="hint-item">✓ Unlimited free lookups</span>
          </div>
        )}
      </form>
    </div>
  );
}
